import React, { useState, useEffect } from 'react';
import { ref, onValue, runTransaction } from 'firebase/database';
import { database } from '../firebase';
import { motion } from 'framer-motion';
import { FiUsers, FiEye } from 'react-icons/fi';
import './VisitorCounter.css';

const VisitorCounter = () => {
  const [visitorCount, setVisitorCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if this is a new visitor
    const hasVisited = localStorage.getItem('hasVisitedWedding');
    
    // Reference to the visitor count in Firebase
    const visitorCountRef = ref(database, 'visitorCount');

    // If first time visitor, increment the count
    if (!hasVisited) {
      runTransaction(visitorCountRef, (currentCount) => {
        return (currentCount || 0) + 1;
      }).then(() => {
        // Mark as visited
        localStorage.setItem('hasVisitedWedding', 'true');
      }).catch((error) => {
        console.error('Error updating visitor count:', error);
      });
    }

    // Listen to real-time updates of visitor count
    const unsubscribe = onValue(visitorCountRef, (snapshot) => {
      const count = snapshot.val() || 0;
      setVisitorCount(count);
      setIsLoading(false);
    }, (error) => {
      console.error('Error reading visitor count:', error);
      setIsLoading(false);
    });

    // Cleanup listener on unmount
    return () => unsubscribe();
  }, []);

  if (isLoading) {
    return (
      <div className="visitor-counter">
        <div className="visitor-counter-content">
          <div className="counter-loading">
            <div className="loading-spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <motion.div 
      className="visitor-counter"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="visitor-counter-content">
        <motion.div 
          className="counter-icon"
          animate={{ 
            scale: [1, 1.1, 1],
          }}
          transition={{ 
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        >
          <FiEye />
        </motion.div>
        
        <div className="counter-details">
          <motion.div 
            className="counter-number"
            key={visitorCount}
            initial={{ scale: 1.2, color: "#d4af37" }}
            animate={{ scale: 1, color: "#2c5aa0" }}
            transition={{ duration: 0.3 }}
          >
            {visitorCount.toLocaleString()}
          </motion.div>
          <div className="counter-label">
            <FiUsers className="users-icon" />
            <span>Total Visitors</span>
          </div>
        </div>

        <motion.div 
          className="counter-decoration"
          animate={{ 
            rotate: [0, 360],
          }}
          transition={{ 
            duration: 20,
            repeat: Infinity,
            ease: "linear"
          }}
        >
          ✨
        </motion.div>
      </div>
    </motion.div>
  );
};

export default VisitorCounter;

